import styled from 'styled-components';

export const Container = styled.div``;

export const Content = styled.div`
  max-width: 1336px;
  width: 100%;
  padding: 40px 20px;
  margin: 0 auto;
  animation: rendering 0.5s;
`;

export const Options = styled.div`
  animation: rendering 0.5s;

  > h1 {
    font-family: 'Aller-Bold';
    font-size: 2rem;
    color: #165011;
  }

  > div {
    margin-top: 40px;

    > button {
      font-family: 'Aller-Regular';
      font-size: 1.5rem;
      width: 260px;
      height: 60px;
    }

    > button:nth-of-type(2) {
      margin-left: 20px;
      color: #61e171;
      border-width: 1px;
      border-style: solid;
      border-color: #61e171;
      background-color: #fff;
    }

    @media (max-width: 35rem) {
      > button:nth-of-type(2) {
        margin-top: 20px;
        margin-left: 0px;
      }
    }
  }
`;

export const Row = styled.div`
  display: flex;

  @media (max-width: 35rem) {
    flex-direction: column;
    align-items: center;
  }
`;

export const FormCreateQuestion = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  animation: rendering 0.5s;

  > h1 {
    font-family: 'Aller-Bold';
    font-size: 2rem;
    color: #165011;
  }

  /* div {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
  } */

  > label {
    display: block;
    font-family: 'Aller-Regular';
    font-size: 1.5rem;
    color: #165011;
    margin: 40px 0px 20px 0px;
  }

  button {
    font-family: 'Aller-Regular';
    font-size: 1.5rem;
    width: 260px;
    height: 60px;
    margin-top: 40px;
    margin: 40px auto 0 auto;
  }

  div {
    width: auto;
  }

  @media (max-width: 35rem) {
    > div {
      width: 100%;
    }
  }
`;

export const TextArea = styled.textarea`
  font-family: 'Aller-Regular';
  font-size: 1.5rem;
  color: #a2a2a2;
  background-color: #fff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  padding: 20px;
  outline: 0;
  border: 0;
  width: auto;
  height: 300px;

  @media (max-width: 35rem) {
    width: 100%;
  }
`;

export const ListOfQuestions = styled.div`
  animation: rendering 0.5s;
  > h1 {
    font-family: 'Aller-Bold';
    font-size: 2rem;
    color: #165011;
    margin-bottom: 40px;
  }

  > button {
    font-family: 'Aller-Regular';
    font-size: 1.5rem;
    width: 260px;
    height: 60px;
    margin-top: 40px;
  }
`;

export const QuestionCard = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  font-family: 'Aller-Light';
  font-size: 1.5rem;
  color: #5c5c5c;
  width: 540px;
  min-height: 80px;
  background-color: #fff;
  padding: 20px 40px 20px 20px;
  margin-bottom: 20px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2) !important;
  transition: all 0.5s;
  &:hover div:nth-child(2) {
    opacity: 1;
    height: auto;
    padding-top: 15px;
    transform: scaleY(1);
  }
  @media (max-width: 36.25rem) {
    width: 100%;
  }
`;

export const Question = styled.div`
  display: flex;
  justify-content: space-between;
  img {
    position: absolute;
    right: 20px;
    cursor: pointer;
  }
`;

export const Answer = styled.div`
  padding: 0;
  font-size: 15px;
  opacity: 0;
  height: 0;
  transition: opacity 0.5s 0.5s;
  transition: padding 0.5s;

  transform: scaleY(0);
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  /* max-width: 540px; */
  > div {
    width: 100%;
    max-width: 540px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  background-color: #ca0909;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  border: 0px;
  outline: 0;
  padding: 0px 10px;
  font-family: 'Aller-Bold';
  font-size: 2.5rem;
  color: #fff;
  cursor: pointer;
  /* transition: all 0.3s; */
  &:hover {
    opacity: 0.9 !important;
  }
`;
